import ge from '../core/ge.js';
/**
 * Same as {@link ge}.
 */
const atLeast = ge;
export default atLeast;
